/**
 * A global namespace for 'addEventListener' string.
 */
const addEventListener = 'addEventListener';
export default addEventListener;
